import Glide from '@glidejs/glide';
import {
    VisibleClass,
    DisableControls,
    LoadingClass,
    preventVerticalScroll,
} from './glideVisible';

export default function initiateSlider() {
    document.querySelectorAll('.glide').forEach((slider) => {
        const track = slider.querySelector('.glide__slides');
        const gap = 14;
        const settings = {
            type: 'slider',
            startAt: 0,
            gap,
            perView: track.dataset.slidesPerView,
            perTouch: 1,
            bound: true,
            hoverpause: track.dataset.slidesHoverPause,
            animationDuration: track.dataset.slidesDuration,
            rewind: false,
            breakpoints: {
                992: {
                    perView: 2,
                },
                768: {
                    perView: 1,
                },
            },
        };

        const mountSettings = {
            VisibleClass,
            DisableControls,
            LoadingClass,
            preventVerticalScroll,
        };
        const glide = new Glide(slider, settings);
        glide.mount(mountSettings);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initiateSlider();
});
